import { IconContent } from '@icons';

export const userFilled: IconContent = {
    sm: '<path d="M2 13a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1H2v-1Z" /><circle cx="8" cy="5" r="3" />',
    md: '<path d="M15.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM6.5 17.5v.5h11v-.5a4 4 0 0 0-4-4h-3a4 4 0 0 0-4 4Z" />',
};
